import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const selectRecipeDefaultVariants = {}
const selectRecipeCompoundVariants = []

const selectRecipeSlotNames = [
  [
    "content",
    "select-content__content"
  ],
  [
    "viewport",
    "select-content__viewport"
  ],
  [
    "item",
    "select-content__item"
  ],
  [
    "arrow",
    "select-content__arrow"
  ]
]
const selectRecipeSlotFns = /* @__PURE__ */ selectRecipeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, selectRecipeDefaultVariants, getSlotCompoundVariant(selectRecipeCompoundVariants, slotName))])

const selectRecipeFn = memo((props = {}) => {
  return Object.fromEntries(selectRecipeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const selectRecipeVariantKeys = [
  "itemDisabled"
]
const getVariantProps = (variants) => ({ ...selectRecipeDefaultVariants, ...compact(variants) })

export const selectRecipe = /* @__PURE__ */ Object.assign(selectRecipeFn, {
  __recipe__: false,
  __name__: 'selectRecipe',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: selectRecipeVariantKeys,
  variantMap: {
  "itemDisabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, selectRecipeVariantKeys)
  },
  getVariantProps
})